import type { ReactNode } from "react";
import { useRelease150 } from "../../lib/release150";

/** A release 1.5.0 route: its page while the switch is on; exactly the 1.4.0 answer (`off`, "not found") while it is off. */
export function Release150Route({ off, children }: { off: ReactNode; children: ReactNode }) {
  return <>{useRelease150() ? children : off}</>;
}
